function NotFoundPage(){
return <h1>PAGE NOT FOUND</h1>
}
export default NotFoundPage;